import { DigitMonitor } from "digit-monitor";
import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./App.css";
import { prefix } from "./config";
import NewsDetail from "./modules/NewsDetail";
import SearchPartner from "./modules/SearchPartner";
import PortalHome from "./PortalHome";

const Monitor = React.memo(() => {
  return (
    <DigitMonitor
      productVersion={"1.0.0"}
      productId={"partner"}
      projectId={"partner-portal"}
      username={""}
    />
  );
});

function App() {
  return (
    <Router>
      <Monitor />
      <Switch>
        <Route exact path={`${prefix}/`}>
          <PortalHome />
        </Route>
        <Route path={`${prefix}/news/:id`} component={NewsDetail} />
        <Route path={`${prefix}/searchPartner`} component={SearchPartner} />
      </Switch>
    </Router>
  );
}

export default App;
